import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List } from 'immutable'
import isEqual from 'lodash/isEqual'
import { formatMessage } from 'lib/intl'
import SelectList from 'components/common/SelectList'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import ArrayHelper from 'helpers/array'

class FilterInputType extends Component {
  onChange = values => {
    const { activeInputTypes, setMyJobsDataViewerFilter } = this.props
    const jobInputTypes = ArrayHelper.getArrData(values, [])

    if (!isEqual(jobInputTypes, activeInputTypes.toArray())) {
      setMyJobsDataViewerFilter({ jobInputTypes })
    }
  }

  render() {
    const { activeInputTypes, inputTypeList } = this.props
    const values = ArrayHelper.getValues(activeInputTypes, inputTypeList)

    return (
      <SelectList
        multiple
        withCheckBox
        hasAllValueOption
        outMultipleValues={{
          all: [],
          empty: ['-1'],
        }}
        variant="outlined"
        name="input_types"
        label={formatMessage('input_types')}
        list={inputTypeList}
        value={values}
        onClose={this.onChange}
        map={{
          index: 'id',
          text: 'name',
        }}
      />
    )
  }
}

FilterInputType.defaultProps = {
  activeInputTypes: List([]),
  inputTypeList: List([]),
}

FilterInputType.propTypes = {
  activeInputTypes: PropTypes.instanceOf(List),
  inputTypeList: PropTypes.instanceOf(List),
  setMyJobsDataViewerFilter: PropTypes.func.isRequired,
}

export default connect(
  store => ({
    activeInputTypes: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'jobInputTypes',
    ]),
    inputTypeList: store.getIn(['myJobsDataViewer', 'filters', 'inputTypes']),
  }),
  {
    setMyJobsDataViewerFilter,
  },
)(FilterInputType)
